export const CATEGORY_EXTRAS_MAP: Record<string, string[]> = {
	"American Style Pizza": [
		"stufe_a",
		"stufe_b",
		"stufe_c",
		"vegan_stufe_a",
		"vegan_stufe_b",
		"vegan_stufe_c",
		"special",
	],
	"American Special Pizza": [
		"stufe_a",
		"stufe_b",
		"stufe_c",
		"vegan_stufe_a",
		"vegan_stufe_b",
		"vegan_stufe_c",
		"special",
	],
	"Italian Pizza": [
		"stufe_a",
		"stufe_b",
		"stufe_c",
		"vegan_stufe_a",
		"vegan_stufe_b",
		"vegan_stufe_c",
		"special",
	],
	"Vegane Pizzen": ["vegan_stufe_a", "vegan_stufe_b", "vegan_stufe_c"],
	"Do it your way": [
		"stufe_a",
		"stufe_b",
		"stufe_c",
		"vegan_stufe_a",
		"vegan_stufe_b",
		"vegan_stufe_c",
		"special",
	],
	"Chicken-Burger": [
		"burger_stufe_a",
		"burger_stufe_b",
		"burger_sauce",
		"burger_stufe_c",
	],
	"Hamburger Gigant": [
		"burger_stufe_a",
		"burger_stufe_b",
		"burger_sauce",
		"burger_stufe_c",
	],
	Nudelgerichte: [
		"pasta",
		"stufe_a",
		"stufe_b",
		"stufe_c",
		"vegan_stufe_a",
		"vegan_stufe_b",
		"vegan_stufe_c",
		"special",
	],
	"Vegane Nudelgerichte": [
		"pasta",
		"stufe_a",
		"stufe_b",
		"stufe_c",
		"vegan_stufe_a",
		"vegan_stufe_b",
		"vegan_stufe_c",
		"special",
	],
	Salate: ["salad"],
	Fleischgerichte: ["meat_dish"],
	"Pizza Baguettes": ["baguette_free", "baguette_paid"],
	Pizzabrötchen: ["pizza_roll"],
	Wraps: ["wrap"],
	Fingerfoods: ["fingerfood"],
	Reisgerichte: ["rice_dish"],
	Backkartoffeln: ["baked_potato"],
};

// ============================================================================
// Utility Functions for Extras Pricing
// ============================================================================

/**
 * Normalize size names for pricing rules lookups
 */
export const getNormalizedSizeName = (sizeName: string): string => {
	const lower = sizeName.toLowerCase();
	if (lower.includes("klein")) return "klein";
	if (lower.includes("mittel")) return "mittel";
	if (lower.includes("pan") || lower.includes("pan-pizza")) return "pan-pizza";
	if (lower.includes("groß") || lower.includes("gross")) return "gross";
	if (lower.includes("blech")) return "blech";
	if (lower.includes("normal")) return "normal";
	return "standard";
};

/**
 * Calculate price for a single extra based on its pricing rules
 * @param extra - The extra item with pricing rules
 * @param sizeName - Optional size name for size-based pricing
 * @returns The calculated price for the extra
 */
export const getExtraPrice = (extra: any, sizeName?: string): number => {
	if (!extra.price) return 0;
	try {
		const pricingRules = JSON.parse(extra.price);
		if (pricingRules.fixedPrice) {
			return pricingRules.fixedPrice;
		}
		if (pricingRules.sizeBased && sizeName) {
			const normalizedSize = getNormalizedSizeName(sizeName);
			return pricingRules.sizeBased[normalizedSize] || 0;
		}
		if (pricingRules.sizeBased) {
			// Fallback to first available price if no size provided
			return (Object.values(pricingRules.sizeBased)[0] as number) || 0;
		}
		return pricingRules.firstFreeExtraPrice || 0;
	} catch (e) {
		return 0;
	}
};

/**
 * Calculate total price for all extras on an item
 * @param extras - Array of extra items
 * @param sizeName - Optional size name for size-based pricing
 * @returns The total price of all extras
 */
export const calculateExtrasTotal = (
	extras: any[],
	sizeName?: string,
): number => {
	return (extras || []).reduce((sum, extra) => {
		return sum + getExtraPrice(extra, sizeName) * extra.quantity;
	}, 0);
};
